const Footer = () => {
  return (
    <div className="text-center bg-regal-blue py-8">
      <p className="text-[#088178] font-semibold">
        © 2024 Buy-Li All Rights Reserved
      </p>
    </div>
  );
};

export default Footer;
